/**
 *
 */
export default class Labelled {

    getContent(order) {
        let content = '<div class="printable" data-order_id="' + order.id + '">Printable</div>';
        return content;
    }
}
